import { render } from "./administrator_page.vue?vue&type=template&id=2b2e2b7d&scoped=true"
import script from "./administrator_page.vue?vue&type=script&lang=js"
export * from "./administrator_page.vue?vue&type=script&lang=js"

import "./administrator_page.vue?vue&type=style&index=0&id=2b2e2b7d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2e2b7d"]])

export default __exports__